import { createElement } from "./create-element"
import { forwardRef } from "./forward-ref"
import { StyledHTMLComponents, domElements, HTMLStyledProps } from "./types"

const styledElements = {}

domElements.forEach((tag) => {
  styledElements[tag] = forwardRef<
    HTMLStyledProps<keyof StyledHTMLComponents>,
    any
  >((props, ref) => createElement(tag, { ...props, ref }))
})

export const styled = styledElements as StyledHTMLComponents
